import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "../components/ui/button";
import { SectionHeading } from "../components/Section";
import { getIcon } from "../lib/icons";
import { getAccessories, formatEUR } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { useLang } from "../i18n/LanguageContext";
import { toast } from "sonner";

const tintGlow = { cyan: "shadow-glow-cyan", mint: "shadow-glow-mint", amber: "shadow-glow-amber", slate: "" };

export default function Accessories() {
  const { t, lang } = useLang();
  const { addToCart } = useStore();
  const [items, setItems] = useState([]);
  useEffect(() => { getAccessories().then((d) => setItems(d.accessories)).catch(() => {}); }, []);

  return (
    <div className="pt-24 pb-16 container-lumeo">
      <SectionHeading eyebrow={t("nav.accessories")} title={t("accessories.title")} subtitle={t("accessories.subtitle")} />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((a) => {
          const Icon = getIcon(a.icon);
          return (
            <div key={a.slug} data-testid={`accessory-${a.slug}`} className="rounded-2xl card-ceramic p-5 flex flex-col group hover:shadow-glow-cyan transition-shadow">
              <span className={`inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-cyanx/10 ${tintGlow[a.tint] || ""}`}><Icon className="h-7 w-7 text-cyanx" /></span>
              <h3 className="mt-4 font-display text-base leading-tight">{lang === "hr" ? a.name_hr : a.name_en}</h3>
              <p className="mt-1 text-xs text-muted-foreground flex-1">{lang === "hr" ? a.desc_hr : a.desc_en}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="font-display text-lg">{formatEUR(a.price_eur)}</span>
                <Button onClick={() => { addToCart({ slug: a.slug, name: lang === "hr" ? a.name_hr : a.name_en, price_eur: a.price_eur, kind: "accessory" }); toast.success(t("common.added")); }} size="sm" className="btn-glow border-0"><Plus className="h-4 w-4" /></Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
